export const STATUS_STYLES = {
  published: "border-emerald-600/40 text-emerald-700 bg-emerald-50",
  in_review: "border-[#D4AF37]/50 text-[#7A5A06] bg-[#FBF3D5]",
  coming_soon: "border-sky-500/40 text-sky-700 bg-sky-50",
  draft: "border-gray-400/40 text-gray-600 bg-gray-100",
  placeholder: "border-gray-400/40 text-gray-600 bg-gray-100",
  planned: "border-violet-500/30 text-violet-700 bg-violet-50",
  confirmed: "border-emerald-600/40 text-emerald-700 bg-emerald-50",
};

export const STATUS_LABEL = {
  published: "Published",
  in_review: "In Review",
  coming_soon: "Coming Soon",
  draft: "Draft",
  placeholder: "CMS Placeholder",
  planned: "Planned",
  confirmed: "Confirmed",
};

export default function StatusBadge({ status, label }) {
  const key = (status || "").toLowerCase();
  const cls = STATUS_STYLES[key] || STATUS_STYLES.draft;
  return (
    <span
      data-testid={`status-badge-${key}`}
      className={`inline-flex items-center bsca-eyebrow px-3 py-1 rounded-full border text-[10px] ${cls}`}
    >
      {label || STATUS_LABEL[key] || status || "—"}
    </span>
  );
}
